uic-list-separator {
  border-bottom: 1px solid var(--uic-color-grey2);
  display: block;
  height: 0;
}
